import React, { useEffect, useState } from "react";
import axios from "axios";

const pages = [
  "Dashboard",
  "Agent Form",
  "All Forms",
  "Reports",
  "Verify Form",
  "Logs",
  "User Create",
  "Non Sale Customer",
  "QA",
  "Campaign",
  "Lead Source",
  "Product",
  "Product Rules",
  "Product Map",
  "Disposition",
  "Source Code",
  "Source Mapping",
  "Campaign Center Mapping",
  "Product Mapping",
  "CenterReportMapping",
  "Reset Password",
  "Uploaded Bins",
  "Center",
  "Edit Password",
  "Create Center",
  "Page Access",
   "QA Assigned",
   "AssessorTask",
   "QAReport",
  
   "Leadsource Center Mapping",     
   "API-MD/ID",
    "API-SC",
    "API-BSN_DMY",
    "API-43_MD"
];

const roles = [
  
  "SuperAdmin",
  "Admin",
  "Team Leader",
  "Manager",
  "Assessor",
  "QA",
  "QA Manager",
  "MIS",
  "MIS Manager",
  "Agent",
  "Verifier",
 
];

const PageAccess = () => {
  const [access, setAccess] = useState({}); // { "Admin": ["Dashboard", ...] }
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const resAccess = await axios.get("https://crm-server-htk6.vercel.app/api/page-access");
        const accessMap = {};
        (resAccess.data || []).forEach((item) => {
          accessMap[item.name] = item.pages || [];
        });
        setAccess(accessMap);
      } catch (err) {
        console.error("❌ Error fetching page access:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // ✅ Toggle page for a Role
  const toggleAccess = (page, role) => {
    setAccess((prev) => {
      const current = new Set(prev[role] || []);
      if (current.has(page)) {
        current.delete(page);
      } else {
        current.add(page);
      }
      return { ...prev, [role]: [...current] };
    });
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      // Create array of { name: role, pages: [...] }
      const roleAccessArray = roles.map((role) => ({
        name: role,
        pages: access[role] || [],
      }));

      await axios.put("https://crm-server-htk6.vercel.app/api/page-access", {
        access: roleAccessArray,
      });

      alert("✅ Page access updated successfully");
    } catch (err) {
      console.error("❌ Error saving access:", err);
      alert("⚠️ Failed to save access");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page" style={{ fontFamily: "Arial", padding: "20px" }}>
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          ⏳ Fetching Roles & Access ...
        </div>
      )}

      <h2 style={{ textAlign: "center", color: "#2a9d8f" }}>🔑 Role-Based Page Access</h2>

      <div style={{ overflowX: "auto", marginTop: "20px", border: "1px solid #ccc" }}>
        <table style={{ minWidth: `${roles.length * 150 + 200}px`, borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f4f4f4" }}>
            <th
  style={{
    padding: "8px",
    border: "1px solid #ddd",
    width: "200px",
    position: "sticky",
    left: 0,
    background: "#75828fff",
    zIndex: 10
  }}
>
  Page
</th>

              {roles.map((role) => (
                <th
                  key={role}
                  style={{
                    padding: "8px",
                    border: "1px solid #ddd",
                    width: "150px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {role}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pages.map((page) => (
              <tr key={page}>
               <td
  style={{
    padding: "8px",
    border: "1px solid #ddd",
    fontWeight: "bold",
    position: "sticky",
    left: 0,
    background: "#75828fff",
    zIndex: 5
  }}
>
  {page}
</td>

                {roles.map((role) => (
                  <td
                    key={role}
                    style={{ textAlign: "center", padding: "8px", border: "1px solid #ddd" }}
                  >
                    <input
                      type="checkbox"
                      checked={(access[role] || []).includes(page)}
                      onChange={() => toggleAccess(page, role)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: "20px", textAlign: "center" }}>
        <button
          onClick={handleSave}
          disabled={loading}
          style={{
            background: "#2a9d8f",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "6px",
            border: "none",
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "⏳ Saving..." : "💾 Save Access"}
        </button>
      </div>
    </div>
  );
};

export default PageAccess;
